export class MockedVitocal200SFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.outlet',
        timestamp: '2020-02-25T21:19:44.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.outlet',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation',
        timestamp: '2020-02-25T21:19:44.389Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation',
      },
      {
        properties: {
          enabled: {
            value: ['0'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.compressors',
        timestamp: '2020-02-25T21:19:44.502Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time',
      },
      {
        properties: {
          value: {
            value: 41,
            type: 'number',
            unit: 'celsius',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2020-02-26T07:22:22.067Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '06:00',
                  end: '08:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              tue: [
                {
                  start: '06:00',
                  end: '08:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              wed: [
                {
                  start: '06:00',
                  end: '08:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '06:00',
                  end: '08:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '06:00',
                  end: '08:00',
                  mode: 'on',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '08:00',
                  end: '22:00',
                  mode: '5/10-cycles',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '08:00',
                  end: '22:00',
                  mode: '5/25-cycles',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.pumps.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['5/25-cycles', '5/10-cycles', 'on'],
                  maxEntries: 8,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation.schedule',
        timestamp: '2020-02-25T21:19:44.468Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit',
      },
      {
        properties: {
          value: {
            value: 43,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2020-02-25T21:19:44.453Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
      },
      {
        properties: {
          value: {
            value: 31.3,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2020-02-26T07:24:15.565Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
      },
      {
        properties: {
          value: {
            value: 5,
            type: 'number',
          },
        },
        commands: {
          setHysteresis: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/setHysteresis',
            name: 'setHysteresis',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 10,
                  stepping: 0.5,
                },
              },
            },
          },
          setHysteresisSwitchOnValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/setHysteresisSwitchOnValue',
            name: 'setHysteresisSwitchOnValue',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 10,
                  stepping: 0.5,
                },
              },
            },
          },
          setHysteresisSwitchOffValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/setHysteresisSwitchOffValue',
            name: 'setHysteresisSwitchOffValue',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0,
                  max: 2.5,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.hysteresis',
        timestamp: '2020-02-25T21:19:44.389Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.hysteresis',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.modes',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.modes',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.normalStandby',
        timestamp: '2020-02-25T21:19:44.383Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.normalStandby',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedReduced',
        timestamp: '2020-02-25T21:19:44.394Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedReduced',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.primary',
        timestamp: '2020-02-25T21:19:44.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.primary',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.power',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.power',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating',
      },
      {
        properties: {
          value: {
            value: 30.7,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.return',
        timestamp: '2020-02-26T07:24:14.202Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.return',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.pumps',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.pumps',
      },
      {
        properties: {
          enabled: {
            value: ['0'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2020-02-25T21:19:44.454Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.fixed',
        timestamp: '2020-02-25T21:19:44.394Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.fixed',
      },
      {
        properties: {
          value: {
            value: 'normal',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2020-02-26T03:59:30.912Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2020-02-25T21:19:44.395Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 0,
          },
          slope: {
            type: 'number',
            value: 0.6,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -15,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2020-02-25T21:19:44.380Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          volumeFlow: {
            value: 20,
            type: 'number',
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelOne',
        timestamp: '2020-02-25T21:19:44.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelOne',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          volumeFlow: {
            value: 20,
            type: 'number',
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelThree',
        timestamp: '2020-02-25T21:19:44.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelThree',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '03:00',
                  end: '07:00',
                  mode: 'temp-2',
                  position: 0,
                },
                {
                  start: '07:00',
                  end: '13:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '13:00',
                  end: '15:00',
                  mode: 'temp-2',
                  position: 2,
                },
                {
                  start: '15:00',
                  end: '21:00',
                  mode: 'normal',
                  position: 3,
                },
              ],
              tue: [
                {
                  start: '03:00',
                  end: '07:10',
                  mode: 'temp-2',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '12:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '13:00',
                  end: '15:00',
                  mode: 'temp-2',
                  position: 2,
                },
                {
                  start: '15:00',
                  end: '22:10',
                  mode: 'normal',
                  position: 3,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'top',
                  position: 0,
                },
              ],
              thu: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'top',
                  position: 0,
                },
              ],
              fri: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'top',
                  position: 0,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'top',
                  position: 0,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '24:00',
                  mode: 'top',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['top', 'normal', 'temp-2'],
                  maxEntries: 8,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2020-02-25T21:19:44.498Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
      },
      {
        properties: {
          value: {
            value: 31.2,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.sensors.temperature.supply',
        timestamp: '2020-02-26T07:23:59.189Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.sensors.temperature.supply',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.standby',
        timestamp: '2020-02-25T21:19:44.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.standby',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.charging',
        timestamp: '2020-02-26T03:46:34.338Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.charging',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [
                {
                  timestamp: '2020-02-24T13:18:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T03:36:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:41:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:11:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:10:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T23:09:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T22:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:33:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:28:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:14:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:01:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T20:53:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-20T16:24:00.000Z',
                  errorCode: '07',
                  status: 'going',
                  priority: 'note',
                  accessLevel: 'maintainer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-20T16:23:00.000Z',
                  errorCode: '07',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'maintainer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-17T10:42:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T09:59:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T08:49:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T07:47:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T07:45:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:34:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:16:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:02:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T18:37:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T18:14:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T16:30:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T16:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T15:46:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T14:53:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T14:47:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
              ],
              current: [
                {
                  timestamp: '2020-02-24T13:18:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T03:36:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:41:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:11:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-24T00:10:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T23:09:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T22:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:33:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:28:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:14:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T21:01:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-23T20:53:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-20T16:24:00.000Z',
                  errorCode: '07',
                  status: 'going',
                  priority: 'note',
                  accessLevel: 'maintainer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-20T16:23:00.000Z',
                  errorCode: '07',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'maintainer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-17T10:42:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T09:59:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T08:49:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T07:47:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T07:45:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:34:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:16:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-11T06:02:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T18:37:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T18:14:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T16:30:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T16:22:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T15:46:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T14:53:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
                {
                  timestamp: '2020-02-10T14:47:00.000Z',
                  errorCode: 'ff',
                  status: 'coming',
                  priority: 'note',
                  accessLevel: 'customer',
                  acknowledged: false,
                  new: false,
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.history',
        timestamp: '2020-02-25T21:19:44.577Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.history',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.sensors.temperature',
      },
      {
        properties: {
          value: {
            value: 30.9,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.return',
        timestamp: '2020-02-26T07:23:59.208Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.return',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 19,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2020-02-26T03:59:30.912Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2020-02-25T21:19:44.385Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.commonSupply',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.commonSupply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeatingCooling',
        timestamp: '2020-02-25T21:19:44.385Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeatingCooling',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors',
      },
      {
        properties: {
          value: {
            value: 43,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.cooling',
        timestamp: '2020-02-25T21:19:44.382Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.cooling',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0',
        timestamp: '2020-02-26T07:24:11.715Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelThree',
                  position: 1,
                },
              ],
              tue: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelThree',
                  position: 1,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelThree',
                  position: 1,
                },
              ],
              thu: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelThree',
                  position: 1,
                },
              ],
              fri: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelThree',
                  position: 1,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelFour',
                  position: 1,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '06:00',
                  mode: 'levelTwo',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '20:00',
                  mode: 'levelFour',
                  position: 1,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['levelTwo', 'levelThree', 'levelFour'],
                  maxEntries: 8,
                  resolution: 10,
                  defaultMode: 'levelOne',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'ventilation.schedule',
        timestamp: '2020-02-25T21:19:44.389Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.schedule',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.sensors.temperature.return',
        timestamp: '2020-02-25T21:19:44.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.sensors.temperature.return',
      },
      {
        properties: {
          value: {
            value: '7733738-device-serial',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  start: '00:00',
                  end: '05:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '05:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:00',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              tue: [
                {
                  start: '00:00',
                  end: '05:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '05:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:00',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              wed: [
                {
                  start: '00:00',
                  end: '05:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '05:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:00',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              thu: [
                {
                  start: '00:00',
                  end: '05:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '05:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:00',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              fri: [
                {
                  start: '00:00',
                  end: '05:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '05:00',
                  end: '22:00',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:00',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              sat: [
                {
                  start: '00:00',
                  end: '08:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '22:40',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:40',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
              sun: [
                {
                  start: '00:00',
                  end: '08:00',
                  mode: 'reduced',
                  position: 0,
                },
                {
                  start: '08:00',
                  end: '22:40',
                  mode: 'normal',
                  position: 1,
                },
                {
                  start: '22:40',
                  end: '24:00',
                  mode: 'reduced',
                  position: 2,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['reduced', 'normal', 'fixed'],
                  maxEntries: 8,
                  resolution: 10,
                  defaultMode: 'standby',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2020-02-25T21:19:44.382Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          volumeFlow: {
            value: 20,
            type: 'number',
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelTwo',
        timestamp: '2020-02-25T21:19:44.391Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelTwo',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device',
        timestamp: '2020-02-25T21:19:44.020Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device',
      },
      {
        properties: {
          value: {
            value: 8.1,
            unit: 'celsius',
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2020-02-26T07:22:48.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2020-02-25T21:19:44.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating',
      },
      {
        properties: {
          value: {
            value: 8,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'celsius',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.sensors.temperature.supply',
        timestamp: '2020-02-26T06:35:12.475Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.sensors.temperature.supply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.circulation',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.circulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.standby',
        timestamp: '2020-02-25T21:19:44.391Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.standby',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2020-02-25T21:19:44.387Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.room',
        timestamp: '2020-02-25T21:19:44.388Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.room',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2020-02-25T21:19:44.382Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2020-02-16T22:20:22.911Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 10,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
      },
      {
        properties: {
          value: {
            value: '7297812919322110',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller.serial',
        timestamp: '2020-02-25T21:19:44.395Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller.serial',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeatingCooling',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'dhw', 'dhwAndHeatingCooling'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2020-02-25T21:19:44.482Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
      },
      {
        properties: {
          value: {
            value: 'ventilation',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'standard', 'ventilation'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.active',
        timestamp: '2020-02-25T21:19:44.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.active',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2020-02-26T03:59:30.876Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.holiday/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.holiday',
        timestamp: '2020-02-25T21:19:44.386Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.holiday',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.sensors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps',
      },
      {
        properties: {
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.circulation',
        timestamp: '2020-02-25T21:19:44.395Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.circulation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.eco/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.eco',
        timestamp: '2020-02-26T03:59:30.902Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.eco',
      },
      {
        properties: {
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2020-02-25T21:19:44.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation',
      },
      {
        properties: {
          value: {
            value: 60,
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.temp2/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.temp2',
        timestamp: '2020-02-25T21:19:44.379Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.temp2',
      },
      {
        properties: {
          runtime: {
            value: 13636115,
            type: 'number',
          },
          runtimeUnit: {
            value: 'seconds',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.mainECU',
        timestamp: '2020-02-26T07:22:20.542Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.mainECU',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.controller',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.controller',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2020-02-25T21:19:44.385Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.solar.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.solar.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.forcedNormal',
        timestamp: '2020-02-25T21:19:44.384Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.forcedNormal',
      },
      {
        properties: {
          value: {
            value: 61,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2020-02-25T21:19:44.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
      },
      {
        properties: {
          date: {
            value: '2019-04-26',
            type: 'string',
          },
          dateFormat: {
            value: 'YYYY-MM-DD',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.initialSetup',
        timestamp: '2020-02-25T21:19:44.378Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.initialSetup',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.levelTwo',
        timestamp: '2020-02-25T21:19:44.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.levelTwo',
      },
      {
        properties: {
          mode: {
            value: 'active',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.cooling/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['none', 'natural', 'natural-mixer', 'active'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.cooling',
        timestamp: '2020-02-25T21:19:44.396Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.cooling',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation',
        timestamp: '2020-02-25T21:19:44.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation',
      },
      {
        properties: {
          value: {
            value: 'levelThree',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.active',
        timestamp: '2020-02-25T21:19:44.394Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.active',
      },
      {
        properties: {
          value: {
            value: 41,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.top',
        timestamp: '2020-02-26T07:22:22.067Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.top',
      },
      {
        properties: {
          starts: {
            value: 5081,
            type: 'number',
          },
          hours: {
            value: 2114.2,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.statistics',
        timestamp: '2020-02-26T07:24:04.378Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.statistics',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2020-02-25T21:19:44.392Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          volumeFlow: {
            value: 20,
            type: 'number',
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelFour',
        timestamp: '2020-02-25T21:19:44.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.programs.levelFour',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating',
        timestamp: '2020-02-25T21:19:44.020Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.ventilation',
        timestamp: '2020-02-25T21:19:44.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ventilation.operating.modes.ventilation',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature',
        timestamp: '2020-02-25T21:19:44.021Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [],
              tue: [],
              wed: [],
              thu: [],
              fri: [],
              sat: [],
              sun: [],
            },
            type: {
              value: 'heatingCircuit',
            },
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.circulation.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['5/25-cycles', '5/10-cycles', 'on'],
                  maxEntries: 8,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.schedule',
        timestamp: '2020-02-25T21:19:44.380Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.schedule',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.bottom',
        timestamp: '2020-02-25T21:19:44.389Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.bottom',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 24,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 23,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.top',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.top',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 22,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.middle',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.middle',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 24,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.midBottom',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.midBottom',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 23,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.dhwCylinder.bottom',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.dhwCylinder.bottom',
        timestamp: '2023-12-01T08:17:41.203Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits',
        timestamp: '2021-02-12T10:02:46.471Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0.reverse',
        timestamp: '2021-02-12T10:02:51.963Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0.reverse',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0',
      },
      {
        properties: {
          entries: {
            value: [
              {
                timestamp: '2021-02-04T18:49:30.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 11,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:49:30.000Z',
                errorCode: '20',
                status: 'inactive',
                count: 9,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:36:17.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 10,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:36:17.000Z',
                errorCode: '20',
                status: 'inactive',
                count: 8,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:23:04.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 9,
                priority: 'note',
              },
            ],
            type: 'array',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0.messages',
        timestamp: '2021-02-12T10:03:24.194Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0.messages',
      },
      {
        properties: {
          value: {
            value: 'Emerson Modbus',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0.eev.type',
        timestamp: '2021-02-12T10:03:03.290Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0.eev.type',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0.eev',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0.eev',
      },
      {
        properties: {
          value: {
            value: 'VC 200-S Emerson',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.0.type',
        timestamp: '2021-02-12T10:03:03.287Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.0.type',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors',
      },
      {
        properties: {
          value: {
            value: 40,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'percent',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.power',
        timestamp: '2021-02-13T10:59:42.339Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.power',
      },
      {
        properties: {
          value: {
            value: 13,
            type: 'number',
          },
          unit: {
            value: 'kilowatt',
            type: 'string',
          },
        },
        commands: {
          setValue: {
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 1,
                  max: 255,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.power',
        timestamp: '2021-02-12T10:03:03.325Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.power',
      },
      {
        properties: {
          hoursLoadClassOne: {
            value: 12,
            type: 'number',
          },
          hoursLoadClassTwo: {
            value: 9,
            type: 'number',
          },
          hoursLoadClassThree: {
            value: 135,
            type: 'number',
          },
          hoursLoadClassFour: {
            value: 1468,
            type: 'number',
          },
          hoursLoadClassFive: {
            value: 644,
            type: 'number',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.statistics.load',
        timestamp: '2021-02-13T10:59:23.237Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.statistics.load',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          phase: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0',
        timestamp: '2021-02-13T10:19:05.985Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.1.sensors',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.1.sensors',
      },
      {
        properties: {
          value: {
            value: 40,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
          unit: {
            value: 'percent',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.1.sensors.power',
        timestamp: '2021-02-13T10:59:42.339Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.1.sensors.power',
      },
      {
        properties: {
          value: {
            value: 13,
            type: 'number',
          },
          unit: {
            value: 'kilowatt',
            type: 'string',
          },
        },
        commands: {
          setValue: {
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 1,
                  max: 255,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.1.power',
        timestamp: '2021-02-12T10:03:03.325Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.1.power',
      },
      {
        properties: {
          starts: {
            value: 1434,
            type: 'number',
          },
          hours: {
            value: 1928.8,
            type: 'number',
          },
          hoursLoadClassOne: {
            value: 15,
            type: 'number',
          },
          hoursLoadClassTwo: {
            value: 8,
            type: 'number',
          },
          hoursLoadClassThree: {
            value: 144,
            type: 'number',
          },
          hoursLoadClassFour: {
            value: 1677,
            type: 'number',
          },
          hoursLoadClassFive: {
            value: 344,
            type: 'number',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.1.statistics',
        timestamp: '2021-02-13T10:59:23.237Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.1.statistics',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          phase: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.1',
        timestamp: '2021-02-13T10:19:05.985Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.1',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.1',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.1',
      },
      {
        properties: {
          entries: {
            value: [
              {
                timestamp: '2021-02-04T18:49:30.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 11,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:49:30.000Z',
                errorCode: '20',
                status: 'inactive',
                count: 9,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:36:17.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 10,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:36:17.000Z',
                errorCode: '20',
                status: 'inactive',
                count: 8,
                priority: 'note',
              },
              {
                timestamp: '2021-02-04T18:23:04.000Z',
                errorCode: '10',
                status: 'inactive',
                count: 9,
                priority: 'note',
              },
            ],
            type: 'array',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.1.messages',
        timestamp: '2021-02-12T10:03:24.194Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.1.messages',
      },
      {
        properties: {
          value: {
            value: 'Emerson Modbus',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.1.eev.type',
        timestamp: '2021-02-12T10:03:03.290Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.1.eev.type',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.1.eev',
        timestamp: '2021-02-12T10:02:46.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.1.eev',
      },
      {
        properties: {
          value: {
            value: 'VC 200-S Emerson',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        gatewayId: gatewaySerial,
        feature: 'heating.coolingCircuits.1.type',
        timestamp: '2021-02-12T10:03:03.287Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.coolingCircuits.1.type',
      },
    ];
  }
}
